import { AsyncPipe, Location, NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import {
  distinctUntilChanged,
  filter,
  map,
  Observable,
  Subject,
  take,
  takeUntil,
} from 'rxjs';
import { ChatBubbleComponent } from '../../../pages/chat/chat-bubble/chat-bubble.component';
import { HomeDistributionListComponent } from '../../../pages/home/home-distribution-list/home-distribution-list.component';
import { HomeUserInformationComponent } from '../../../pages/home/home-user-information/home-user-information.component';
import { NotificationListV2Component } from '../../../pages/notification/notification-list-v2/notification-list-v2.component';
import { DistributionTemplate } from '../../enum';
import { IMessage } from '../../interface/common';
import { AzureAdService } from '../../services/azure-ad.service';
import { BackPortalService } from '../../services/back-portal.service';
import { CollapseLayoutService } from '../../services/collapseLayout.service';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';
import { DistributionService } from '../../services/distribution.service';
import { LoaderLayOut } from '../../services/loaderLayOut.service';
import { NotificationService } from '../../services/notification.service';
import { ApplicationInsightsService } from '../../services/telemetry.service';
import { UserInfoService } from '../../services/user-info.service';
import { WebSocketService } from '../../services/web-socket.service';
import { DialogActionApp, OptionButtonType } from '../../type';
import { AppConstant } from '../../utilities/app.constant';
import { AppHelper } from '../../utilities/app.helper';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { NotificationCenterComponent } from '../notification-center/notification-center.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TutorialCenterComponent } from '../tutorial-center/tutorial-center.component';
import { ExtendInfoComponent } from 'src/app/pages/notification/extend-info/extend-info.component';

const MESSAGE_ALERT_USER_DELETED =
  'You currently do not have enough permissions to access the system, please contact admin.';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [MessageService],
  imports: [
    HeaderComponent,
    SidebarComponent,
    NgClass,
    NgStyle,
    NgIf,
    NotificationListV2Component,
    NotificationCenterComponent,
    TutorialCenterComponent,
    HomeUserInformationComponent,
    HomeDistributionListComponent,
    FooterComponent,
    ToastModule,
    PrimeTemplate,
    MatIcon,
    ChatBubbleComponent,
    AsyncPipe,
    ExtendInfoComponent,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  defaultImage =
    '../../../../assets/images/backgrounds/VRO-backgound-login.png';
  image = '../../../../assets/images/backgrounds/VRO-backgound-login.png';

  isLoading: boolean = false;

  currentPath: string = '';

  displaySidebarUserInfomation: boolean = false;
  loginUser: any;

  isSupporter: boolean = false;
  isAdmin: boolean = false;
  isCollapse = true;
  isLiveSupportPage: boolean = false;

  notifications: IMessage = {
    type: '',
    header: '',
    content: '',
    time: '',
  };

  isOneWiget = true;

  expandMenu: boolean = false;
  notificationPanelExpanded = false;
  tutorialPanelExpanded = false;

  private destroy$ = new Subject<void>();

  public isCollapse$: Observable<any>;
  public distributionRender$: Observable<any>;
  public distributionData$: Observable<any>;
  public distributionURL$: Observable<any>;

  public render = {
    isShow: false,
    template: DistributionTemplate.uploadYet,
    reuploadStatus: false,
  };
  public data = {
    rigId: '',
    rigJournalId: '',
    rigOperator: '',
    rigProject: '',
    rigName: '',
    language: '',
  };

  public link = {
    distributionUrl: '',
  };

  isOneColumGrid$;
  isLoginRoute$;
  isNewAssetPage$;

  constructor(
    private _router: Router,
    private _userInfoService: UserInfoService,
    private _notificationService: NotificationService,
    private _messageService: MessageService,
    private _msalService: MsalService,
    public _azureAdService: AzureAdService,
    private _location: Location,
    private _loaderLayOut: LoaderLayOut,
    private _io: WebSocketService,
    private _backPortalService: BackPortalService,
    private _confirmService: ConfirmDialogService,
    private _collapseLayoutService: CollapseLayoutService,
    private _distributionService: DistributionService,
    private _applicationInsightsService: ApplicationInsightsService
  ) {
    this.isCollapse$ = this._collapseLayoutService.isCollapse$;

    this.distributionRender$ = this._distributionService.distributionRender$;
    this.distributionData$ = this._distributionService.distributionData$;
    this.distributionURL$ = this._distributionService.distributionURL$;

    this.distributionRender$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ render }: any) => {
        if (render) {
          if (render.template === DistributionTemplate.uploadYetReload) {
            render.reuploadStatus = AppHelper.MathFunctions.getRandomNumber();
            render.template = DistributionTemplate.uploaded;
          } else {
            render.reuploadStatus = false;
          }
          this.render = render;
        }
      });

    this.distributionData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }: any) => {
        if (data) {
          this.data = data;
        }
      });

    this.distributionURL$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ link }: any) => {
        if (link) {
          this.link = link;
        }
      });

    this.isOneColumGrid$ = _router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(
        event =>
          event.url.includes('login') ||
          event.url.includes('user/team-management') ||
          event.url.includes('rig/rig-management') ||
          event.url.includes('mailbox/mailbox-management') ||
          event.url.includes('help-center') ||
          event.url.includes('live-support') ||
          event.url.includes('alerts/alerts-management') ||
          event.url.includes('distribution-list')
      )
    );
    this.isLoginRoute$ = _router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event.url.includes('login'))
    );
    this.isNewAssetPage$ = _router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(
        event =>
          event.url.includes('home/new-asset') ||
          event.url.includes('home/edit-asset')
      )
    );
  }

  // Add the HostListener to the component class
  @HostListener('window:resize')
  onWindowResize() {
    // Get the window width
    const windowWidth = window.innerWidth;
    // Check the window width against your specific breakpoint
    if (
      windowWidth <= AppConstant.RESOLUTION_BREAKPOINT.HD_PLUS &&
      !(
        this.hasRoute('login') ||
        this.hasRoute('user/team-management') ||
        this.hasRoute('rig/rig-management') ||
        this.hasRoute('mailbox/mailbox-management') ||
        this.hasRoute('help-center') ||
        this.hasRoute('alerts/alerts-management') ||
        this.hasRoute('distribution-list')
      )
    ) {
      // Adjust the value as needed
      this.isCollapse = false; // Change the value Colapse Notification List
    } else {
      this.isCollapse = true; // Change back to default value Colapse Notification List
    }
  }

  ngOnInit() {
    this._userInfoService.userSubject$
      .pipe(
        filter((userObject: any) => !!userObject),
        take(1)
      )
      .subscribe((userObject: any) => {
        this.isSupporter =
          userObject.role === AppConstant.ROLES.SUPPORT.value.data;
        this.isAdmin = userObject.role === AppConstant.ROLES.ADMIN.value.data;
      });

    this.getCurrentUrl()
      .pipe(takeUntil(this.destroy$))
      .subscribe((url: string) => {
        this.currentPath = url === '/' ? 'home' : url;
        this.isLiveSupportPage = this.currentPath.includes('live-support');
      });

    this._loaderLayOut.loadingStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        // Tracking the loading panel based on current route without re-subscribing per navigation.
        if (
          (this.currentPath === '/' ||
            this.currentPath === 'home' ||
            this.currentPath === '/home' ||
            this.currentPath === '/home?view=card' ||
            this.currentPath === '/home?view=table') &&
          state.InterventionListAPI === true &&
          state.ProjectListAPI === true &&
          (state.userInfoAPI === true ||
            this._loaderLayOut.tasksState.userInfoAPI === true)
        ) {
          this._loaderLayOut.tasksState.InterventionListAPI = true; // just in case
          this._loaderLayOut.tasksState.ProjectListAPI = false;
          this._loaderLayOut.tasksState.userInfoAPI = true;
        }
      });

    this._loaderLayOut.interventionFormDone$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDone: boolean) => {
        if (isDone) {
          this.isLoading = false;
          // Send Signal to layout turn off loading from Initial Form Detail
          this._loaderLayOut.setLoadingInterventionDone(false);
        }
      });

    this._loaderLayOut.alertsDetailDone$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDone: boolean) => {
        if (isDone) {
          this.isLoading = false;
          // Send Signal to layout turn off loading from Alert Detail
          this._loaderLayOut.setLoadingAlertsDetailDone(false);
        }
      });

    // Notification on/off
    this._collapseLayoutService.toggleNotificationPanel$
      .pipe(takeUntil(this.destroy$))
      .subscribe(flag => (this.notificationPanelExpanded = flag));

    // Tutorial on/off
    this._collapseLayoutService.toggleTutorialPanel$
      .pipe(takeUntil(this.destroy$))
      .subscribe(flag => (this.tutorialPanelExpanded = flag));

    // set display User Panel
    this._userInfoService.isShowUserPanel
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => {
        const currentAccount = this._msalService.instance.getActiveAccount();
        this.loginUser = currentAccount;
        this.displaySidebarUserInfomation = status;
      });

    // Always running to listen and update notifications
    this._notificationService.messageSubjectAction$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message: IMessage) => {
        this.notifications = message;
        const statusCode: number = Number(this.notifications.header);

        if (message.type === AppConstant.MESSAGE_TYPE.ERROR) {
          this._applicationInsightsService.trackException({
            error: new Error(`[Catched error] ${message?.content}`),
          });
        }

        switch (statusCode) {
          case 401:
            this.showDialogRequiresLogout();
            break;
          case 503:
            this.showDialogMaintenance();
            break;
          default:
            this.showMessage(this.notifications);
            this.sendSystemNotification(message);
            break;
        }

        this.isLoading = false;
      });

    // Listen for collapse intervetion log status
    this._backPortalService.collapseInterventionLog$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: boolean) => {
        this.isCollapse = status;
      });

    // Final case to ensure that loading will off
    setTimeout(() => {
      this.isLoading = false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showDialogRequiresLogout() {
    this._confirmService.setDialog({
      isVisible: true,
      header: 'Information',
      haveDialogMessage: true,
      dialogMessage: MESSAGE_ALERT_USER_DELETED,
      havePrimaryButton: true,
      primaryButtonLabel: 'Logout',
      isValidPrimaryButton: true,
      disablePrimaryButton: false,
      buttonEvent: (event: OptionButtonType) =>
        this.onButtonClickDialog(event, 'UserRemove'),
    });
  }

  showDialogMaintenance() {
    this._confirmService.setDialog({
      isVisible: true,
      header: 'Information',
      haveDialogMessage: true,
      dialogMessage:
        'Server is under maintenance please try again later. Thanks you',
      havePrimaryButton: true,
      primaryButtonLabel: 'Back',
      isValidPrimaryButton: true,
      disablePrimaryButton: false,
      buttonEvent: (event: OptionButtonType) =>
        this.onButtonClickDialog(event, 'Maintance'),
    });
  }

  hasRoute(route: string) {
    return this._router.url.includes(route);
  }

  changeSizeOfNotification(value: boolean) {
    this.isCollapse = value;
  }

  showMessage(msgPackage: IMessage) {
    this._messageService.add({
      // sticky: true,
      severity: msgPackage.type,
      summary: msgPackage.header,
      detail: msgPackage.content + '/br' + msgPackage.time,
      data: { keepCase: !!msgPackage.keepCase },
      ...(/\(s\)/i.test(msgPackage.header) ? { styleClass: 'toast-keep-plural' } : {}),
    });
  }

  sendSystemNotification(msgPackage: IMessage) {
    if (msgPackage.header === '' || msgPackage.content === '') {
      return;
    }
    this._io.emit(`notification_events/system`, {
      title: msgPackage.header,
      message: msgPackage.content,
      userId: this.loginUser?.localAccountId || 'Unknown User',
    });
  }

  onButtonClickDialog(
    option: OptionButtonType,
    dialogType: DialogActionApp
  ): void {
    switch (option) {
      case AppConstant.OPTION_BUTTON.YES:
        switch (dialogType) {
          case 'Maintance':
            this._location.back();
            break;
          case 'Login':
            this.login_Azure();
            break;
          case 'UserRemove':
            this._msalService.logout();
            break;
          default:
            this._confirmService.clearDialog();
            break;
        }
        break;
      case AppConstant.OPTION_BUTTON.NO:
        this._confirmService.clearDialog();
        break;
      case AppConstant.OPTION_BUTTON.CANCEL:
        this._confirmService.clearDialog();
        break;
      default:
        break;
    }
  }

  login_Azure() {
    this._msalService.loginRedirect();
  }

  expandMenuEvent(event: any) {
    this.expandMenu = event;
  }

  getCurrentUrl(): Observable<string> {
    return this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url),
      distinctUntilChanged()
    );
  }
}
